import { httpCreate } from './http';

const http = httpCreate('/srv/gather-watch-config/');

export const gatherWatchConfig = {
	save(gatherId, params) {
		return http.post(`save/${gatherId}`, params);
	},
	getSurveyList(gatherId) {
		return http.get('/surveyList', { gatherId: gatherId });
	},
	unboundSurvey(gatherId) {
		return http.post(`/survey/unBound/${gatherId}`);
	},
	// 新版合集管理
	// 获取观看方式
	gatherWatchConfig(gatherId, params) {
		return http.get(`/${gatherId}`, { params });
	},
};
